import { render, staticRenderFns } from "./LinkWrapper.vue?vue&type=template&id=44932b4f&scoped=true"
import script from "./LinkWrapper.vue?vue&type=script&lang=js"
export * from "./LinkWrapper.vue?vue&type=script&lang=js"
import style0 from "./LinkWrapper.vue?vue&type=style&index=0&id=44932b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44932b4f",
  null
  
)

export default component.exports